import { useState } from 'react'
import { useSpace } from '@/hooks/useSpace'

import HandoverProductionLine from '@/ui/advancedAssistants/MMA/components/Handover/HandoverProductionLine'

import type { SelectOption } from '@/ui/advancedAssistants/MMA/types/Filter'

// styles
import './HandoverModal.scss'
import useAvailableLines from '@/hooks/useAvailableLines'

// the enum is shared with mmaDialogs and FollowUpMessage
// eslint-disable-next-line react-refresh/only-export-components
export enum HANDOVER_TYPE {
    SOLUTION = 'solution',
    NO_SOLUTION = 'no-solution',
}

interface HandoverModalProps {
    onSelect: (lines: SelectOption[]) => void
    translate: (key: string) => string
    handoverType: HANDOVER_TYPE
    solutionText?: string
}

const HandoverModal = ({
    onSelect,
    translate,
    handoverType,
    solutionText,
}: HandoverModalProps) => {
    const [lineSelection, setLineSelection] = useState<SelectOption[]>([])
    const extractedSolution = solutionText
        ?.match(/\*Solution:\*\s*([\s\S]*)/)?.[1]
        ?.trim()
    const { spaces, getActiveSpace } = useSpace()
    const availableLines = useAvailableLines(spaces, getActiveSpace)

    const onLineSelect = (selectedOptions: SelectOption[]) => {
        setLineSelection(selectedOptions)
        onSelect(
            selectedOptions.map((option) => ({
                value: option.value,
                label: option.label,
            }))
        )
    }

    return (
        <div className="handover-modal__content">
            <div>{translate('handover:description')}</div>
            {handoverType === HANDOVER_TYPE.SOLUTION && (
                <div>
                    <b>
                        <span>{translate('handover:solutionPrefix')} </span>
                        <span>{extractedSolution}</span>
                    </b>
                </div>
            )}
            <HandoverProductionLine
                lines={availableLines}
                selection={lineSelection}
                onSelect={onLineSelect}
                translate={translate}
            />
        </div>
    )
}

export default HandoverModal
